import { OrganizerSharedLayoutModalConfigInterface } from '~/organizer/shared/components/shared/layouts/funnel/interfaces/modal-config.interface';

export const organizerActivityCreationLeaveModalConfig: OrganizerSharedLayoutModalConfigInterface =
  {
    headerKey: 'activity_creation.leave_modal.header',
    contentKey: 'activity_creation.leave_modal.content',
    labelKey: 'activity_creation.leave_modal.label',
    redirectRouteName: 'organizer.planning.planning',
  };
